import { PageConstant } from './../../../constant/page.constant';
import { SpriteConstant } from 'src/app/constant/sprite.constant';
import {
  Component,
  EventEmitter,
  HostListener,
  Input,
  OnInit,
  Output,
} from '@angular/core';

@Component({
    templateUrl: '../../../template/noop.template.html',
    standalone: false
})
export class ComingSoonLayoutComponent implements OnInit {
  @Input() data: any;
  @Output() eventEmit: EventEmitter<string> = new EventEmitter<string>();
  menu_icons: any;
  currentLanguage: any;
  version = '';
  constructor() {
    this.menu_icons = SpriteConstant.MENU_ICONS;
  }

  @HostListener('document:keydown.escape', ['$event']) onKeydownHandler(
    event: KeyboardEvent
  ) {
    this.onCloseClick();
  }

  onCloseClick = (event = null) => {
    this.eventEmit.emit('close');
  };

  onAlertImageClick = (event = null) => {
    //console.log('onAlertImageClick');
    this.eventEmit.emit(this.data.iconStr);
  };

  ngOnInit() {
    this.version = PageConstant.VERSION;
    if (this.data && this.data.currentLanguage) {
      this.currentLanguage = this.data.currentLanguage;
      //console.log("ComingSoonLayoutComponent..",this.currentLanguage)
    }
  }
}
